import { useCallback } from 'react';

import { formatChartLabel, formatChartTick } from './formatDate';

export function useChartDateFormatters(locale?: string) {
  const tickFormatter = useCallback((value: Date | string | undefined) => formatChartTick(value, locale ?? 'en-US'), [locale]);

  const formatXLabel = useCallback((label: Date | string | undefined) => formatChartLabel(label, locale ?? 'en-US'), [locale]);

  return { tickFormatter, formatXLabel };
}
